export default __webpack_public_path__ + "static/media/hcilLogo.e16e7dcf.png";